/**
 * The file types the app opens: from the command line, from Explorer, and
 * dropped onto a window. Shared, so the ways in cannot disagree.
 */
export const OPENABLE = /\.(md|markdown|mdown|mkd|txt)$/i
